// ========================================
// HOOK useHomePage
// Gestion du contenu de la page d'accueil
// ========================================

import { useState, useEffect, useCallback } from 'react';
import {
  getHomeContent,
  updateHero,
  updateIntroduction,
  updateSypnase,
  updateServices,
  updateFeaturedProjects,
  updateHomeContent
} from '../services/firebase/homeService';
import { toast } from 'react-toastify';

const useHomePage = (autoFetch = true) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  // Charger le contenu
  const fetchContent = useCallback(async () => {
    setLoading(true);
    setError(null);

    const result = await getHomeContent();

    if (result.success) {
      setContent(result.data);
    } else {
      setError(result.error);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    if (autoFetch) {
      fetchContent();
    }
  }, [autoFetch, fetchContent]);

  // Sauvegarder le hero
  const saveHero = async (heroData) => {
    setSaving(true);
    const result = await updateHero(heroData);

    if (result.success) {
      setContent(prev => ({ ...prev, hero: heroData }));
      toast.success('Section Hero sauvegardée !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }

    setSaving(false);
    return result;
  };

  // Sauvegarder l'introduction
  const saveIntroduction = async (introData) => {
    setSaving(true);
    const result = await updateIntroduction(introData);

    if (result.success) {
      setContent(prev => ({ ...prev, introduction: introData }));
      toast.success('Introduction sauvegardée !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }

    setSaving(false);
    return result;
  };

  // Sauvegarder Sypnase
  const saveSypnase = async (sypnaseData) => {
    setSaving(true);
    const result = await updateSypnase(sypnaseData);

    if (result.success) {
      setContent(prev => ({ ...prev, sypnase: sypnaseData }));
      toast.success('Section Sypnase sauvegardée !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }

    setSaving(false);
    return result;
  };

  // Sauvegarder les services
  const saveServices = async (services) => {
    setSaving(true);
    const result = await updateServices(services);

    if (result.success) {
      setContent(prev => ({ ...prev, services }));
      toast.success('Services sauvegardés !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }

    setSaving(false);
    return result;
  };

  // Sauvegarder les projets en vedette
  const saveFeaturedProjects = async (projectIds) => {
    setSaving(true);
    const result = await updateFeaturedProjects(projectIds);

    if (result.success) {
      setContent(prev => ({ ...prev, featuredProjects: projectIds }));
      toast.success('Projets en vedette sauvegardés !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }

    setSaving(false);
    return result;
  };

  // Sauvegarder tout le contenu
  const saveAllContent = async (newContent) => {
    setSaving(true);
    const result = await updateHomeContent(newContent);

    if (result.success) {
      setContent(newContent);
      toast.success('Page d\'accueil sauvegardée !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }

    setSaving(false);
    return result;
  };

  return {
    content,
    loading,
    saving,
    error,
    fetchContent,
    saveHero,
    saveIntroduction,
    saveSypnase,
    saveServices,
    saveFeaturedProjects,
    saveAllContent
  };
};

export default useHomePage;